const CLOUD_PROVIDERS = {
    AWS: 'AWS',
    AZURE: 'AZURE',
    KUBERNETES: 'KUBERNETES',
    VMWARE: 'VMWARE',
    CUSTOM: 'CUSTOM',
    GCP: "GCP",
};

export default CLOUD_PROVIDERS;